import { render, staticRenderFns } from "./ExpenseManagement.vue?vue&type=template&id=df64a872&scoped=true&"
import script from "./ExpenseManagement.vue?vue&type=script&lang=js&"
export * from "./ExpenseManagement.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseManagement.vue?vue&type=style&index=0&id=df64a872&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df64a872",
  null
  
)

export default component.exports